import { ButtonBase, styled as muiStyled } from '@mui/material'

export const AddSubscriberButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    padding: 8px 16px;
    border-radius: 5px;
    display: relative;
    background: rgba(var(--cui-primary-rgb), 1);
    color: white;
    :disabled{
        background: rgba(var(--cui-primary-rgb), 0.5);
    }
    transition: background 0.5s ${theme.transitions.easing.quickInOut};
    &:hover{
        background: rgba(var(--cui-primary-rgb), 0.8);
    }
`,
)
